import { render } from "./site-title.vue?vue&type=template&id=435e1938&ts=true"
import script from "./site-title.vue?vue&type=script&lang=ts"
export * from "./site-title.vue?vue&type=script&lang=ts"

import "./site-title.vue?vue&type=style&index=0&id=435e1938&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__